import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import NotFoundComponent from "@/components/NotFound.vue";
import TotalCareServiceView from "@/views/TotalCareServiceView.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/total-care-service',
    name: 'totalCareService',
    component: TotalCareServiceView
  },
  {
    path: '/:catchall(.*)',
    component: NotFoundComponent,
    name: 'NotFound'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
